import type React from "react";
import { Box, Button } from "@mui/material";

interface SubmitSectionProps {
  totalAssignments: number;
  onSubmit: () => void;
  showSection?: boolean;
}

const SubmitSection: React.FC<SubmitSectionProps> = ({
  totalAssignments: _totalAssignments,
  onSubmit: _onSubmit,
  showSection = true,
}) => {
  void _totalAssignments;
  void _onSubmit;
  if (!showSection) return null;

  return (
    <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
      <Button
        variant="contained"
        color="primary"
        size="large"
        disabled
        sx={{ minWidth: 200 }}
      >
        Add New Crew Member
      </Button>
      <Button
        variant="contained"
        color="primary"
        size="large"
        disabled
        sx={{ minWidth: 200 }}
      >
        Add New Role
      </Button>
    </Box>
  );
};

export default SubmitSection;
